<template>
    <div>
        <bs-card class="card-info" :icon="['fal', 'globe-asia']" :label="$t('labels.' + camelToSnake($options.name))">
            <template v-slot:header>
                <bs-button v-if="auth.can['edit_customer_properties']" class="btn-sm btn-info" @click="create">{{ $t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.create') }) }}</bs-button>
            </template>
            <div style="height:430px;">
                <mapbox :sources="resources.data" />
            </div>
            <bs-table v-bind="{dataLength, loading}" :cols="4">
                <template v-slot:thead>
                    <tr>
                        <bs-th :label="$t('labels.label')" :sortable="resourceState.sort" :col="'label'" @click="applySort"></bs-th>
                        <bs-th :label="$t('labels.aprox_center')" @click="applySort"></bs-th>
                        <th></th>
                    </tr>
                </template>
                <tr v-for="r in resources.data" :key="r.id">
                    <td>{{ r.label }}</td>
                    <td>
                        <span class="mr-2">{{ $t('labels.lat', { lat: r.aprox_center[1]}) }}</span>
                        <span>{{ $t('labels.lng', { lng: r.aprox_center[0]}) }}</span>
                    </td>
                    <td class="t3">
                        <bs-action v-if="auth.can['edit_customer_properties']" :icon="['fal', 'pencil']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.edit') })" class="btn-info" @click="update(r)"></bs-action>
                        <bs-action v-if="auth.can['edit_customer_properties']" :icon="['fal', 'trash']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })" class="btn-danger" @click="destroy(r)"></bs-action>
                    </td>
                </tr>
            </bs-table>
        </bs-card>
        <bs-modal :name="'create-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: resource.id ? $t('labels.edit') : $t('labels.create') })">
            <bs-form :submit="$t('labels.submit')" @submit="submit">
                <template v-slot:default="slotProps">
                    <tuxedo-input :name="'label'" :label="$t('labels.label')" v-model="resource.label" :error="slotProps.error" />
                    <map-polygon :name="'boundary'" :label="$t('labels.boundary')" v-model="resource.boundary" :error="slotProps.error" :reDraw="reDraw" @mousePosition="mousePosition"></map-polygon>
                    <input-field :name="'search'" :label="$t('labels.search')" v-model="resource.search" :error="slotProps.error">
                        <template v-slot:lappend>
                            <button class="btn btn-outline-info" type="button" @click="searchforProperty">
                                <fa-icon :icon="['fal', 'search']"></fa-icon>
                            </button>
                        </template>
                    </input-field>
                </template>
            </bs-form>
        </bs-modal>
        <bs-modal :name="'destroy-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })">
            <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
                {{ $t('messages.delete', { resource: $t('labels.contact') }) }}
            </bs-form>
        </bs-modal>
        <portal to="app-footer">
            <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
        </portal>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import queue from '../../router/queue'
import Vue from 'vue'

export default {
  name: 'Properties',
  props: ['customer'],
  data () {
    return {
      loading: false,
      dataLoading: false,
      activeId: null,
      reDraw: false,
      assignedClients: [],
      resource: {
        label: '',
        boundary: null,
        search: null
      }
    }
  },
  mounted () {
    this.index(this.page)
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resourceState: state => state.propertiesState,
      resources: state => state.properties,
      submitting: state => state.submitting
    }),
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.resourceState.tableRows - length, 0)
    }
  },
  methods: {
    ...mapMutations([
      'pushState'
    ]),
    mousePosition (val) {
      Vue.set(this.resource, 'search', val.toString())
    },
    applySort (val) {
      this.pushState({ view: this.$options.name, key: 'sort', data: val })
      this.index()
    },
    searchforProperty () {
      queue.post('api/properties/in-bounds', { point: this.resource.search, message: 'Searching properties' })
        .then(response => {
          if (response.data) {
            this.resource.label = response.data.data.label
            this.resource.boundary = response.data.data.boundary
            this.reDraw = !this.reDraw
          }
        })
    },
    index (page, count) {
      if (page) this.pushState({ view: this.$options.name, key: 'page', data: page })
      if (count) this.pushState({ view: this.$options.name, key: 'tableRows', data: count })
      this.loading = true
      this.$store.dispatch('index', { collection: this.$options.name, path: 'customers', id: this.customer, tag: 'properties' }).then(() => {
        this.loading = false
      })
    },
    create () {
      this.$store.commit('axiosError', null)
      this.resource.boundary = null
      this.$root.clearData(this.resource)
      this.$modal.show('create-' + this.$options.name)
    },
    destroy (o) {
      this.activeId = o.id
      this.$modal.show('destroy-' + this.$options.name)
    },
    update (o) {
      this.$store.commit('axiosError', null)
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('create-' + this.$options.name)
    },
    submit () {
      this.$store.dispatch(this.resource.id ? 'update' : 'store', { collection: this.$options.name, path: 'customers', id: this.customer, tag: 'properties', resource: this.resource }).then(() => {
        this.$modal.hide('create-' + this.$options.name)
      })
    },
    destruction () {
      this.$store.dispatch('destroy', { collection: this.$options.name, id: this.activeId }).then(() => {
        this.$modal.hide('destroy-' + this.$options.name)
      })
    }
  }
}
</script>
